export enum Environment {
  dev = 'dev',
  qa = 'qa',
  uat = 'uat',
  prod = 'prod',
}
